'use client';

import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Chip } from '@packages/shared/src/ui/Chip/Chip';
import { useIntl } from 'react-intl';

export type ScrollTopButtonProps = {};

export const ScrollTopButton: FC<ScrollTopButtonProps> = () => {
  const [show, setShow] = useState(false);
  const { formatMessage } = useIntl();
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.pageYOffset > window.innerHeight);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`transition-opacity duration-300 ${show ? 'opacity-100' : 'opacity-0'}`}>
      <Chip
        className="text-[13px] shadow-md"
        iconPosition="start"
        iconClassName="icon-emp-arrow-medium-up mx-0.5"
        onClick={scrollToTop}
        label={formatMessage({
          id: 'scrollToTopButton',
          defaultMessage: 'Nach oben',
        })}
      />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default ScrollTopButton;
